import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useShortcutsStore = defineStore('shortcuts', () => {
  const shortcuts = ref([
    { id: 1, name: 'GitHub', url: 'https://github.com', icon: 'github' },
    { id: 2, name: 'GitCode', url: 'https://gitcode.com', icon: 'gitcode' },
    { id: 3, name: 'AWS Academy', url: 'https://www.awsacademy.com/vforcesite/LMS_Login', icon: 'aws' },
    { id: 4, name: 'ChatGPT', url: 'https://chatgpt.com/', icon: 'chatgpt' }
  ])

  const editingMode = ref(false)

  function addShortcut(shortcut) {
    const newId = Math.max(...shortcuts.value.map(s => s.id), 0) + 1
    shortcuts.value.push({ ...shortcut, id: newId })
  }

  function removeShortcut(id) {
    shortcuts.value = shortcuts.value.filter(s => s.id !== id)
  }

  function updateShortcut(id, data) {
    const index = shortcuts.value.findIndex(s => s.id === id)
    if (index !== -1) {
      shortcuts.value[index] = { ...shortcuts.value[index], ...data }
    }
  }

  function reorderShortcuts(fromIndex, toIndex) {
    const [removed] = shortcuts.value.splice(fromIndex, 1)
    shortcuts.value.splice(toIndex, 0, removed)
  }

  function toggleEditMode() {
    editingMode.value = !editingMode.value
  }

  return {
    shortcuts,
    editingMode,
    addShortcut,
    removeShortcut,
    updateShortcut,
    reorderShortcuts,
    toggleEditMode
  }
}, {
  persist: true
})
